module.exports = __webpack_public_path__ + "media/images/icons/medical-cross-9b24a1d3847d4e32f8cd6189eb655071.svg";